<template>
  <div class="pa-4">
    <h2 class="ml-4 my-4">{{ $t('message.packages') }}</h2>
    <div v-if="loading" class="text-center">
      <circles-loader></circles-loader>
    </div>
    <div v-else-if="academyPackage" class="text-center">
      <v-card-title class="pb-0 mb-0">
        <v-text-field outlined dense :label="$t('message.name')" outline v-model="academyPackage.name"></v-text-field>
      </v-card-title>
      <v-card-text>
        <v-switch v-model="academyPackage.active" :label="$t('message.active')"></v-switch>
        <v-switch v-model="academyPackage.automatic" :label="$t('message.distribute_automatically')"></v-switch>
        <div class="supporting-text text-left">{{ $t('message.distribute_automatically_explained') }}</div>
        <div v-if="academyPackage.automatic">
          <v-radio-group v-model="academyPackage.distributionRules">
            <v-radio :label="$t('message.all_members')" :value="'all'"></v-radio>
            <v-radio :label="$t('message.minors_only')" :value="'minors'"></v-radio>
            <v-radio :label="$t('message.adults_only')" :value="'adults'"></v-radio>
            <v-radio :label="$t('message.non_bjj')" :value="'no-bjj'"></v-radio>
          </v-radio-group>
        </div>
      </v-card-text>
      <v-card-text v-if="academyPackage.templates">
        <v-autocomplete :items="availableTemplates" item-text="name" v-model="selectedTemplate"
          :label="$t('message.add_document_template')" item-value="_id" outlined dense></v-autocomplete>
        <v-list class="text-left">
          <v-subheader>{{ $t('message.templates') }}</v-subheader>
          <v-list-item v-for="(item, i) in packageTemplates" :key="i">
            <v-list-item-action>
              <span class="mb-1">
                <DocumentTextIcon color="gray"></DocumentTextIcon>
              </span>

            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title :style="!item.active ? 'color:gray' : ''" v-text="item.name"></v-list-item-title>
            </v-list-item-content>
            <v-list-item-action>
              <v-tooltip bottom v-if="!item.active">
                <template v-slot:activator="{ on, attrs }">
                  <XCircleIcon class="hero-icon-button" v-bind="attrs" v-on="on"></XCircleIcon>
                </template>
                <span>{{ $t('message.template_inactive') }}</span>
              </v-tooltip>
            </v-list-item-action>
            <v-list-item-action>
              <v-btn icon small @click="removeTemplateFromPackage(item._id)">
                <TrashIcon color="gray" class="hero-icon-button"></TrashIcon>
              </v-btn>
            </v-list-item-action>
          </v-list-item>
        </v-list>
      </v-card-text>
      <v-card-text v-if="academyPackage && academyPackage.lastUpdatedBy" class="text-left">
        <v-avatar size="20">
          <img v-if="academyPackage.lastUpdatedBy.userImageSmall"
            :src="userImg(academyPackage.lastUpdatedBy.userImageSmall)" />
          <img v-else :src="assets('default-profile-avatar.png')" />
        </v-avatar>
        {{ $t('message.last_update_by') }}
        {{ academyPackage.lastUpdatedBy.displayName }}
        <span style="color:gray">{{ $d(new Date(academyPackage.lastUpdatedOn), 'short', $i18n.locale) }}</span>
      </v-card-text>
      <v-card-actions>
        <v-btn outlined v-allowed="'create_waiver'"
          v-if="academyPackageId == 'new' && academyPackage.name && academyPackage.templates && academyPackage.templates.length > 0"
          color="primary" small elevation="0" @click="creatAcademyPackage()">{{ $t('message.create') }}</v-btn>
        <v-btn outlined v-allowed="'create_waiver'" small elevation="0" v-else-if="this.academyPackage.name"
          color="primary" @click="updateAcademyPackage()">{{ $t('message.update') }}</v-btn>
        <v-btn small elevation="0" class="ml-2" @click="goBack()">{{ $t('message.back') }}</v-btn>
      </v-card-actions>
    </div>
  </div>
</template>

<script>
import Api from "@/services/Api";
import CirclesLoader from "@/components/displays/CirclesLoader.vue";

import {
  TrashIcon,
  DocumentTextIcon,
  XCircleIcon
} from '@vue-hero-icons/outline'

export default {
  data() {
    return {
      academyPackageId: this.$route.params.academyPackageId,
      academyPackage: null,
      loading: true,
      availableTemplates: [],
      selectedTemplate: null,
      packageTemplates: [],
    };
  },
  components: {
    CirclesLoader,
    XCircleIcon,
    TrashIcon,
    DocumentTextIcon,
  },
  mounted() {
  },
  created() {
    if (this.academyPackageId == "new") {
      this.academyPackage = {
        active: true,
        name: null,
        templates: [],
        managedAcademy: this.$store.state.managedAcademy,
      };
      this.init();
    } else {
      this.getAcademyPackage();
    }
    Api()
      .get(
        "documents/academy/" + this.$store.state.managedAcademy + "/templates"
      )
      .then((response) => {
        const data = response.data;
        if (data) {
          const templates = data;
          if (templates) {
            this.availableTemplates = [];
            for (const d of templates) {
              if (d.active)
                this.availableTemplates.push({
                  name: d.name,
                  _id: d._id,
                  active: true,
                });
            }
          }
        }
      });
    this.loading = false;
  },
  watch: {
    selectedTemplate: {
      handler: function (newValue) {
        this.addTemplateToPackage(newValue);
      },
    },
  },
  methods: {
    removeTemplateFromPackage(id) {
      console.log('remove: ', id);
      let index = 0;
      for (const t of this.packageTemplates) {
        if (id == t._id) {
          this.packageTemplates.splice(index, 1);
          this.academyPackage.templates.splice(index, 1);
          break;
        }
        index++;
      }
    },
    addTemplateToPackage(templateId) {
      for (const t of this.availableTemplates) {
        if (templateId == t._id) {
          this.packageTemplates.push(t);
          this.academyPackage.templates.push(templateId);
          this.selectedTemplate = '';
          break;
        }
      }
    },
    init() {
    },
    getAcademyPackage() {
      Api()
        .get(
          "documents/academy/" +
          this.$store.state.managedAcademy +
          "/packages/" +
          this.academyPackageId
        )
        .then((response) => {
          if (response) {
            this.academyPackage = response.data.package;
            this.packageTemplates = response.data.package.templates;
            let tmp = [];
            for (const t of response.data.package.templates) {
              tmp.push(t._id);
            }
            this.academyPackage.templates = tmp;
            this.init();
          }
        })
        .catch((e) => {
          if (e)
            this.showAlert("error", "Oops!", this.$t("message.error_generic"));
        });
    },
    creatAcademyPackage() {
      if (!this.academyPackage.name) {
        this.showAlert("error", "Oops!", this.$t("message.error_generic"));
        return;
      }
      if (!this.academyPackage.automatic) {
        this.academyPackage.distributionRules = null;
      }
      Api()
        .post(
          "documents/academy/" +
          this.$store.state.managedAcademy +
          "/packages",
          this.academyPackage
        )
        .then((response) => {
          if (response) {
            this.academyPackageId = response.data._id;
            this.showAlert("success", this.$t("message.success"));
          }
        })
        .catch((e) => {
          if (e)
            this.showAlert("error", "Oops!", this.$t("message.error_generic"));
        });
    },
    updateAcademyPackage() {
      if (!this.academyPackage.automatic) {
        this.academyPackage.distributionRules = null;
      }
      Api()
        .patch(
          "documents/academy/" +
          this.$store.state.managedAcademy +
          "/packages/" +
          this.academyPackageId,
          this.academyPackage
        )
        .then((response) => {
          if (response) {
            this.showAlert("success", this.$t("message.success"));
          }
        })
        .catch((e) => {
          if (e)
            this.showAlert("error", "Oops!", this.$t("message.error_generic"));
        });
    },
  },
};
</script>

<style scoped>
.question-card {
  border-bottom: 2px solid #f5f5f5;
}
</style>